import { Search } from "lucide-react";


const SearchField = ({ searchQuery, setSearchQuery }) => {
  return (
    <div className="relative lg:w-96 w-full">
      <input
        type="text"
        placeholder="Search"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="serachfield w-full bg-[#EAEAEA] rounded-md placeholder:text-[#5B5B5B] pl-10 py-2 border border-transparent focus:outline-none focus:border-gray-400"
      />
      <Search
        className="absolute left-4 top-1/2 transform -translate-y-1/2 text-[#5B5B5B] size-4.5"
        size={16}
      />

    </div>
  );
};

export default SearchField;
